import { get, isEmpty, map, sumBy } from 'lodash';

import { createSelector } from 'reselect';
import { parseTime } from '../../utils/chart-utils';

// DMARC Message Volume Coverage report selectors
const rawMessageVolumeCoverageSelector = state => get( state, 'dmarc.messageVolumeCoverage', {} );
export const messageVolumeCoverageIsLoadingSelector = state => get( state, 'dmarc.messageVolumeCoverageIsLoading', false );
export const messageVolumeCoverageIsLoadedSelector = state => !get( state, 'dmarc.messageVolumeCoverageIsLoading', false ) && !isEmpty( get( state, 'dmarc.messageVolumeCoverage', {} ) );
export const prevMessageVolumeCoverageParamsSelector = state => get( state, 'dmarc.messageVolumeCoverageParams' );

export const messageVolumeTableIsExportingGridToCSV = state => get( state, 'exportReport.isExportingCSV.messageVolume', false );

export const flattenedMessageVolumeCoverageSelector = createSelector( rawMessageVolumeCoverageSelector, ( rawData ) => {
    return map( rawData, ( row, date ) => {
        const { invalid, monitor, none, quarantine, reject, total } = row;

        const totalInvalid = invalid;
        const totalMonitor = monitor;
        const totalNone = none;
        const totalQuarantine = quarantine;
        const totalReject = reject;

        let percentInvalid = 0,
            percentMonitor = 0,
            percentNone = 0,
            percentQuarantine = 0,
            percentReject = 0;

        if( total > 0 ){
            percentInvalid = ( totalInvalid / total ) * 100;
            percentMonitor = ( totalMonitor / total ) * 100;
            percentNone = ( totalNone / total ) * 100;
            percentQuarantine = ( totalQuarantine / total ) * 100;
            percentReject = ( totalReject / total ) * 100;
        };

        return {
            date,
            percentInvalid: percentInvalid.toFixed( 2 ),
            percentMonitor: percentMonitor.toFixed( 2 ),
            percentNone: percentNone.toFixed( 2 ),
            percentQuarantine: percentQuarantine.toFixed( 2 ),
            percentReject: percentReject.toFixed( 2 ),
            total,
            totalInvalid,
            totalMonitor,
            totalNone,
            totalQuarantine,
            totalReject,
        };
    } );
} );

export const messageVolumeCoverageVisSelector = createSelector( rawMessageVolumeCoverageSelector, ( rawData ) => {
    const formattedData = map( rawData, ( row, date ) => {

        let percentQuarantine = 0;
        let percentReject = 0;

        if( row.total !== 0 ){
            percentQuarantine = ( row.quarantine / row.total ) * 100;
            percentReject = ( row.reject / row.total ) * 100;
        };

        return {
            date: parseTime( '%Y-%m-%d' )( date ),
            percentCoveredByPolicy: ( percentReject + percentQuarantine ).toFixed( 2 ),
            total: row.total
        };
    } );

    return formattedData;
} );

export const avgMessageVolumeProtectionRateSelector = createSelector(
    flattenedMessageVolumeCoverageSelector,
    ( messageVolumeCoverageData ) => {
        const sumReject = sumBy( messageVolumeCoverageData, 'totalReject' );
        const sumQuarantine = sumBy( messageVolumeCoverageData, 'totalQuarantine' );
        const sumTotal = sumBy( messageVolumeCoverageData, 'total' );

        const avg = ( ( sumReject + sumQuarantine ) / sumTotal ) * 100 || 0;

        return avg.toFixed( 2 );
    }
);
